import React from 'react';
import PropTypes from 'prop-types';
import { Box, Button } from '@mui/material';
import { Add as AddIcon } from '@mui/icons-material';

const HeaderPrimaryAction = ({ label, ariaLabel, onClick, disabled, icon, sx }) => (
  <Button
    variant="contained"
    onClick={onClick}
    disabled={disabled}
    aria-label={ariaLabel || label}
    title={label}
    startIcon={icon}
    sx={{
      width: { xs: 44, md: 'auto' },
      minWidth: { xs: 44, md: 'auto' },
      height: 44,
      px: { xs: 0, md: 2 },
      borderRadius: 2,
      flexShrink: 0,
      textTransform: 'none',
      fontWeight: 700,
      '& .MuiButton-startIcon': { m: { xs: 0, md: '0 8px 0 -4px' } },
      ...sx,
    }}
  >
    <Box component="span" sx={{ display: { xs: 'none', md: 'inline' } }}>
      {label}
    </Box>
  </Button>
);

HeaderPrimaryAction.propTypes = {
  label: PropTypes.string.isRequired,
  ariaLabel: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  icon: PropTypes.node,
  sx: PropTypes.object,
};

HeaderPrimaryAction.defaultProps = {
  ariaLabel: '',
  disabled: false,
  icon: <AddIcon />,
  sx: {},
};

export default HeaderPrimaryAction;
